<template>
  <div>
    <v-app>
      <NavegacionSubCliente v-if="usuario !== null && usuario.rol_codigo === ROL_SUBCLIENTE" />
      <v-navigation-drawer permanent :rail="rail" class="drawer-style" mobile-breakpoint="0" touchless
        disable-resize-watcher>
        <v-list>
          <v-list-item-group v-model="menuSeleccionado">
            <v-list-item class="list-item-menu" @click="accionMenu('Vehiculos')">
              <template v-slot:prepend>
                <v-icon @click.stop="rail = !rail"
                  class="icono-menu-vertical app-text-success">mdi-car-multiple</v-icon>
                <v-icon class="icono-flecha app-text-success" small @click.stop="rail = !rail">
                  {{ !rail ? 'mdi-chevron-left' : 'mdi-chevron-right' }}
                </v-icon>
              </template>
              <v-list-item-title>Vehículos</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="usuario && usuario.tipo_pago === 'CON_ANTICIPO'" class="list-item-menu"
              @click="accionMenu('Anticipos')">
              <template v-slot:prepend>
                <v-icon @click.stop="rail = !rail"
                  class="icono-menu-vertical app-text-success">mdi-cash-multiple</v-icon>
                <v-icon class="icono-flecha app-text-success" small @click.stop="rail = !rail">
                  {{ !rail ? 'mdi-chevron-left' : 'mdi-chevron-right' }}
                </v-icon>
              </template>
              <v-list-item-title>Anticipos</v-list-item-title>
            </v-list-item>
            <v-list-item class="list-item-menu" @click="accionMenu('Autorizaciones')">
              <template v-slot:prepend>
                <v-icon @click.stop="rail = !rail" class="icono-menu-vertical app-text-success">mdi-gas-station</v-icon>
                <v-icon class="icono-flecha app-text-success" small @click.stop="rail = !rail">
                  {{ !rail ? 'mdi-chevron-left' : 'mdi-chevron-right' }}
                </v-icon>
              </template>
              <v-list-item-title>Autorización</v-list-item-title>
            </v-list-item>
            <v-list-item class="list-item-menu" @click="accionMenu('Servicios')">
              <template v-slot:prepend>
                <v-icon @click.stop="rail = !rail"
                  class="icono-menu-vertical app-text-success">mdi-gas-station-in-use-outline</v-icon>
                <v-icon class="icono-flecha app-text-success" small @click.stop="rail = !rail">
                  {{ !rail ? 'mdi-chevron-left' : 'mdi-chevron-right' }}
                </v-icon>
              </template>
              <v-list-item-title>Servicios</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
      <v-main class="informacion-principal" :style="{ 'padding-left': rail ? '57px' : '175px' }">
        <router-view />
      </v-main>
    </v-app>
  </div>
</template>

<script>
import NavegacionAdmin from '@/components/Navegacion/NavegacionAdmin.vue'
import NavegacionIslero from '@/components/Navegacion/NavegacionIslero.vue'
import NavegacionCliente from '@/components/Navegacion/NavegacionCliente.vue'
import NavegacionSubCliente from '@/components/Navegacion/NavegacionSubcliente.vue'
import Footer from '@/components/parciales/Footer.vue'
import { mapGetters, mapActions } from "vuex";
import { Constantes } from '@/util/Constantes';

export default {
  name: 'MainLayout',
  components: {
    NavegacionAdmin,
    NavegacionCliente,
    NavegacionIslero,
    NavegacionSubCliente,
    Footer
  },
  data() {
    return {
      ruta_servidor: this.axios.defaults.baseURL,
      show: false,
      rail: true,
      menuSeleccionado: null,
      ROL_ADMIN: Constantes.ROL_ADMIN,
      ROL_ISLERO: Constantes.ROL_ISLERO,
      ROL_CLIENTE: Constantes.ROL_CLIENTE,
      ROL_SUBCLIENTE: Constantes.ROL_SUBCLIENTE
    };
  },
  methods: {
    ...mapActions(['cerrarSesion']),
    accionMenu(opcion) {
      if (opcion === "Vehiculos" && !this.rail) {
        this.$router.push('/app/subcliente/vehiculos-subcliente')
        this.minimizarMenu()
      } else if (opcion === "Autorizaciones" && !this.rail) {
        this.$router.push('/app/subcliente/autorizaciones-subcliente')
        this.minimizarMenu()
      }  else if (opcion === "Servicios" && !this.rail) {
        this.$router.push('/app/subcliente/servicios-subcliente')
        this.minimizarMenu()
      } else if (opcion === "Anticipos" && !this.rail) {
        this.$router.push('/app/subcliente/anticipos-subcliente')
        this.minimizarMenu()
      } else if (opcion === "Cerrar") {
        this.cerrarSesion()
      }
    },
    minimizarMenu() {
      this.rail = !this.rail;
    }
  },
  computed: {
    ...mapGetters(['usuario'])
  }
}
</script>
<style scoped>
.drawer-style {
  max-width: 175px;
  height: 100vh;
  background-color: var(--gray-color);
  z-index: 10;
  transition: max-width 0.2s ease-in-out;
}

.drawer-style .v-list-item {
  color: #000;
  /* Color del texto */
}

.drawer-style :deep(.v-list-item-title) {
  text-align: left;
  font-size: 15px;
}

.drawer-style :deep(.v-list-item__prepend) {
  margin-right: -30px !important;
}

.v-icon {
  text-align: left !important;
}

.v-icon {
  font-size: 32px;
  font-weight: bold;
}
</style>
